import { render, staticRenderFns } from "./ModernInputNumber.vue?vue&type=template&id=8dbc0122&scoped=true"
import script from "./ModernInputNumber.vue?vue&type=script&lang=js"
export * from "./ModernInputNumber.vue?vue&type=script&lang=js"
import style0 from "./ModernInputNumber.vue?vue&type=style&index=0&id=8dbc0122&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbc0122",
  null
  
)

export default component.exports